import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReqBodyBuscaListadoReportes } from 'src/app/interfaces/reporte-consulta-estado-seccion';
import { IReqBodyGeneraSolicitudReporte, IResBuscaListadoReportes, IResGeneraSolicitudReporte } from 'src/app/interfaces/reporte-ponderaciones-individuales';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportePonderacionesIndividualesService {
  constructor(private http: HttpClient) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getReporteBytes(idSolicitudReporte: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-ponderacion-individual/obtener-reporte-bytes?idSolicitudReporte=${idSolicitudReporte}`
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }

  postGeneraSolicitudReporte(reqBody: IReqBodyGeneraSolicitudReporte): Observable<IResGeneraSolicitudReporte> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-ponderacion-individual/generaSolicitudReporte`
    return this.http.post<IResGeneraSolicitudReporte>(url, reqBody, { headers: this.getHeaders() })
  }

  postBuscaListadoReportes(reqBody: IReqBodyBuscaListadoReportes): Observable<IResBuscaListadoReportes> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-ponderacion-individual/buscaListadoReportes`
    return this.http.post<IResBuscaListadoReportes>(url, reqBody, { headers: this.getHeaders() })
  }  
}
